// extracted by mini-css-extract-plugin
export default {"itemAdpCard":"MdEhJ","adpContainer":"_1X2by","titleAdp":"_22IxT","adpWrapper":"_2CMD8","labelAdp":"_15m1z","amountAdp":"nxi_f"};